import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { convertObjToString } from "../helper";

export const clickOptIn = (
    tipAmount: string,
    optIn: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_OPT_IN,
        label: String(optIn),
        context: tipAmount,
    });
};

export const clickCustomTipAmount = (
    tipAmount: string,
    optIn: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TIP_AMOUNT_CUSTOM,
        label: tipAmount,
        context: convertObjToString({
            "opt-in-value": optIn,
        }),
    });
};

export const clickTipAmountPredefined = (
    tipAmount: string,
    optIn: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TIP_AMOUNT_PREDEF,
        label: tipAmount,
        context: convertObjToString({
            "opt-in-value": optIn,
        }),
    });
};

export const impressionTippingWidget = (
    mostTippedValue: number,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TIPPING_WIDGET,
        context: String(mostTippedValue),
    });
};
